import { render, staticRenderFns } from "./ModalSendAttribution.vue?vue&type=template&id=7bfd2d28&scoped=true"
import script from "./ModalSendAttribution.vue?vue&type=script&lang=js"
export * from "./ModalSendAttribution.vue?vue&type=script&lang=js"
import style0 from "./ModalSendAttribution.vue?vue&type=style&index=0&id=7bfd2d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd2d28",
  null
  
)

export default component.exports